import React from "react";
import { Flex, Text, useColorModeValue } from "@chakra-ui/react";

export const EmptySelectedSegments = () => {
  return (
    <Flex
      align="center"
      bg={useColorModeValue("white", "navy.800")}
      borderRadius="lg"
      direction="column"
      height="155px"
      justify="center"
      py={6}
      shadow="sm"
    >
      <Text
        color={useColorModeValue("gray.500", "gray.400")}
        fontSize="md"
        fontWeight="medium"
      >
        Select segments to begin editing
      </Text>
    </Flex>
  );
};
